import { createGlobalStyle, keyframes } from 'styled-components'
import { Z_INDEX } from '../constants/zIndex'

export default createGlobalStyle`
  * {
    margin: 0;
    pad: 0;
    box-sizing: border-box;

    -ms-overflow-style: none;
    ::-webkit-scrollbar {
    display: none;
}
  }
  
  body {
    background: ${props => props.theme.colors.background};
    font-size: 14px;
    color: ${props => props.theme.colors.text};
    font-family: Roboto;
  }

  /* Garantir que os toasts sempre tenham prioridade de clique */
  .Toastify__toast-container {
    z-index: ${Z_INDEX.TOAST} !important;
    pointer-events: auto !important;
    position: fixed !important;
  }
  
  .Toastify__toast {
    pointer-events: auto !important;
    position: relative !important;
    cursor: pointer !important;
    z-index: inherit !important;
  }
  
  .Toastify__toast-body,
  .Toastify__close-button {
    pointer-events: auto !important;
    cursor: pointer !important;
  }
  
  /* Garantir que elementos dentro do toast sejam clicáveis */
  .Toastify__toast * {
    pointer-events: auto !important;
  }
  
  /* Container do portal deve estar acima de tudo */
  #toast-portal-root {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    pointer-events: none !important;
    z-index: ${Z_INDEX.TOAST} !important;
  }
  
  /* Mas os toasts dentro do portal devem ser clicáveis */
  #toast-portal-root .Toastify__toast-container {
    pointer-events: auto !important;
  }
  
  #toast-portal-root .Toastify__toast {
    pointer-events: auto !important;
  }
`

export const glow = keyframes`
  0% {
    box-shadow: 0 0 5px rgba(0, 150, 255, 0.6);
  }
  50% {
    box-shadow: 0 0 15px rgba(0, 150, 255, 1);
  }
  100% {
    box-shadow: 0 0 5px rgba(0, 150, 255, 0.6);
  }
`;